<div class="panel" (click)="active=!active" id="bs-collapse">
  <div [ngClass]="{'active': active}" class="panel-heading" >
    <h4 class="panel-title active" >
      <a href="javascript:void(0)">
        {{question}}
      </a>
    </h4>
  </div>
  <div *ngIf="active" id="{{id}}" class="panel-collapse collapse" [ngClass]="{'show': active}">
    <div class="panel-body">
      {{answer}}
    </div>
  </div>
</div>
